"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const InputSearch_1 = __importDefault(require("components/cosmos/InputSearch"));
const translate_1 = require("components/translate");
const useDebounce_1 = __importDefault(require("hooks/useDebounce"));
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const folderList_1 = __importDefault(require("./containers/folderList"));
const MIN_SEARCH_TERM_LENGTH = 3;
const FilesTab = ({ t }) => {
    const [search, setSearch] = (0, react_1.useState)('');
    const debouncedSearch = (0, useDebounce_1.default)(search);
    return ((0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsx)(InputSearch_1.default, { value: search, onChange: (event) => setSearch(event.target.value), className: "_w-full _mb-6", placeholder: t('player_backoffice.file_explorer.label_type_file_name') }), (0, jsx_runtime_1.jsx)("section", { children: (0, jsx_runtime_1.jsx)(folderList_1.default, { searchTerm: debouncedSearch.length >= MIN_SEARCH_TERM_LENGTH
                        ? debouncedSearch
                        : '' }) })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)())(FilesTab);
